<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Dark Table" pageTitle="Dark Table" />
            <DarkTable />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import DarkTable from '../DarkTable/DarkTable'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'DarkTablePage',
    components: {
        MainHeader,
        PageTitle,
        DarkTable,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>